import {
  FaCheckCircle,
  FaChartLine,
  FaHeadset,
  FaLaptopCode,
  FaTools,
} from "react-icons/fa";
import styles from "./Section1.module.css";

const highlights = [
  {
    title: "20+ Years Of Expertise",
    text: "Our experience helps us deliver dependable websites, outreach support, and marketing solutions with confidence.",
    icon: FaTools,
  },
  {
    title: "Results-Focused Thinking",
    text: "We build digital services around visibility, lead generation, and long-term business growth.",
    icon: FaChartLine,
  },
  {
    title: "Dedicated Support",
    text: "From planning to launch, we help keep your digital presence clear, updated, and working smoothly.",
    icon: FaHeadset,
  },
  {
    title: "Modern Tools And Execution",
    text: "We combine design, development, and marketing tools that help your brand stay current and competitive.",
    icon: FaLaptopCode,
  },
];

export default function Section1() {
  return (
    <section className={styles.section}>
      <div className={`container ${styles.shell}`}>
        <div className={styles.headerBlock}>
          <span className={styles.eyebrow}>Digital Services</span>
          <h2>Comprehensive digital marketing and development services.</h2>
          <p>
            We create WordPress websites, custom-built solutions,
            telemarketing support, and digital marketing strategies that help
            businesses grow with stronger presentation and better online reach.
          </p>

          <div className={styles.inlineNote}>
            <FaCheckCircle />
            <span>Simple, user-friendly, and fully responsive service experience.</span>
          </div>
        </div>

        <div className={styles.cardGrid}>
          {highlights.map((item) => {
            const Icon = item.icon;

            return (
              <article key={item.title} className={styles.card}>
                <span className={styles.iconWrap}>
                  <Icon />
                </span>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
